import React from "react";
import { IMAGES } from "../../lib/constants";
import { ArrowRight, ShieldCheck, Truck, MapPin } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative border-b-2 border-[#122A1E] overflow-hidden bg-[#122A1E]"
      data-testid="hero-section"
    >
      <img
        src={IMAGES.hero}
        alt="Heavy-duty semi-truck hauling an RV through the Canadian Rockies — direct-carrier coast-to-coast transport"
        fetchPriority="high"
        decoding="async"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#122A1E]/95 via-[#122A1E]/70 to-[#122A1E]/20" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-32 lg:py-40">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6 reveal">
            <span className="w-8 h-[2px] bg-[#FF5A00]" />
            <span className="font-mono-accent text-[11px] uppercase text-[#F4F4F1]/80">
              Coast · to · Coast · Canada
            </span>
          </div>

          <h1
            className="font-display font-black uppercase tracking-tighter leading-[0.85] text-[#F4F4F1] text-[clamp(44px,8vw,120px)] reveal"
            style={{ animationDelay: "0.05s" }}
            data-testid="hero-headline"
          >
            We Haul.
            <br />
            <span className="text-[#FF5A00]">We Don't Broker.</span>
          </h1>

          <p
            className="mt-7 text-[#F4F4F1]/85 text-lg md:text-xl max-w-xl font-medium reveal"
            style={{ animationDelay: "0.15s" }}
            data-testid="hero-subheadline"
          >
            Direct-carrier door-to-door transport for RVs, motorcycles, ATVs,
            snowmobiles and boats. Your keys, our hands — never a middleman.
          </p>

          <div className="mt-9 flex flex-wrap gap-3 reveal" style={{ animationDelay: "0.25s" }}>
            <a
              href="#quote"
              className="inline-flex items-center gap-2 bg-[#FF5A00] hover:bg-[#E04F00] text-white font-display font-bold uppercase text-sm tracking-wider px-6 py-4 border-2 border-[#F4F4F1] hover-lift"
              data-testid="hero-cta-quote"
            >
              Get Instant Quote <ArrowRight size={16} />
            </a>
            <a
              href="#services"
              className="inline-flex items-center gap-2 bg-transparent hover:bg-[#F4F4F1] hover:text-[#122A1E] text-[#F4F4F1] font-display font-bold uppercase text-sm tracking-wider px-6 py-4 border-2 border-[#F4F4F1] transition-colors"
              data-testid="hero-cta-services"
            >
              Our Services
            </a>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-4 max-w-xl reveal" style={{ animationDelay: "0.35s" }}>
            {[
              { icon: Truck, label: "Our Own Fleet" },
              { icon: ShieldCheck, label: "Fully Insured" },
              { icon: MapPin, label: "11 Provinces & Territories" },
            ].map((item, i) => (
              <div key={i} className="border-2 border-[#F4F4F1]/40 p-3">
                <item.icon size={18} className="text-[#FF5A00]" />
                <div className="font-mono-accent text-[10px] uppercase text-[#F4F4F1]/80 mt-2">
                  {item.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative border-t-2 border-[#F4F4F1]/30 bg-[#0C1D14]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-3 flex flex-wrap gap-x-10 gap-y-2 justify-between items-center">
          {["RV TRANSPORT", "MOTORCYCLE SHIPPING", "ATV & SXS", "SNOWMOBILE", "MARINE & BOAT"].map((t) => (
            <span key={t} className="font-mono-accent text-[10px] text-[#F4F4F1]/70 uppercase">
              ◆ {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
